<!-- 
    * 设置相关，目前屏幕的左下角
    * 点击设置按钮，可以弹出一系列设置按钮
 -->
<template>
    <div class="toolBar">
        <div class="toolBarHead" @click="showToolBar"><i class="el-icon-setting" ></i></div>
        <transition  
            name="animate__animated animate__bounce" 
            enter-active-class="animate__fadeInLeftBig" 
            leave-active-class="animate__bounceOutLeft"> 
        <div class="toolBarBody" v-show="isShowToolBar">
            <span class="toolBarItem">
            <el-tooltip class="item" effect="dark" content="图层设置" placement="top">
                <i class="el-icon-coin el-icon" @click="showMapProvider"></i>
            </el-tooltip>
            </span>
            <span class="toolBarItem">
            <el-tooltip class="item" effect="dark" content="动态云层设置" placement="top">
                <i class="el-icon-cloudy-and-sunny el-icon" @click="showDynamicCloud"></i>
            </el-tooltip>
            </span>
            <span class="toolBarItem">
            <el-tooltip class="item" effect="dark" content="雾灯列表" placement="top">
                <i class="el-icon-document el-icon" @click="showLEDHostList"></i>
            </el-tooltip>
            </span>
            <span class="toolBarItem">
              <el-tooltip class="item" effect="dark" content="巡检" placement="top">
                  <i class="el-icon-first-aid-kit el-icon inspection"  @click="showFollowStyle"></i>
              </el-tooltip>
              <transition  
                name="animate__animated animate__bounce" 
                enter-active-class="animate__bounceInLeft" 
                leave-active-class="animate__bounceOutLeft"> 
                <div class="inspectionDiv" v-show="isShowFollowStyle">
                  <span class="toolBarItem spanItem">
                    <el-tooltip class="item" effect="dark" content="俯视跟随" placement="top">
                        <i class="el-icon-caret-bottom el-icon" @click="trackOverlay('TP')"></i>
                    </el-tooltip>
                  </span>
                  <span class="toolBarItem spanItem">
                    <el-tooltip class="item" effect="dark" content="第一人称跟随" placement="top">
                        <i class="el-icon-view el-icon" @click="trackOverlay('FP')"></i>
                    </el-tooltip>
                  </span>
                  <span class="toolBarItem spanItem">
                    <el-tooltip class="item" effect="dark" content="取消跟随" placement="top">
                        <i class="el-icon-delete-location el-icon" @click="trackOverlay('FREE')"></i>
                    </el-tooltip>
                  </span>
                </div>
              </transition>
            </span>
            <span class="toolBarItem">
              <el-tooltip class="item" effect="dark" content="系统信息" placement="top">
                  <i class="el-icon-s-operation el-icon" @click="showSystemInfo"></i>
              </el-tooltip>
            </span>
            <span class="toolBarItem">
              <el-tooltip class="item" effect="dark" content="图表监测" placement="top">
                  <i class="el-icon-s-data el-icon" @click="showLEDEcharts"></i>
              </el-tooltip>
            </span>
            <span class="toolBarItem">
              <el-tooltip class="item" effect="dark" content="设备分布图" placement="top">
                  <i class="el-icon-picture-outline el-icon" @click="showEchartsAreas"></i>
              </el-tooltip>
            </span>
            <span class="toolBarItem">
              <el-tooltip class="item" effect="dark" content="Right Top 提示文字" placement="top">
                  <i class="el-icon-delete el-icon"></i>
              </el-tooltip>
            </span>
        </div>
        </transition>    
    </div>
</template>

<script>
import  $bus  from '../bus.ts'
export default {
    name:'ToolBar',
    props:['controlLEDRoadShow'],
    data(){
        return {
          isShowToolBar: false,
          isShowLEDHostList: false,
          isShowFollowStyle:false,
        }
    },
    methods:{
      showMapProvider(){
        // this.isShowMapProvider = !this.isShowMapProvider ;
        this.$bus.emit('showMapProvider');
      },
      showToolBar(){
          this.isShowToolBar = !this.isShowToolBar ;
      },
      showDynamicCloud(){
        this.$bus.emit('showDynamicCloud');
      },
      showLEDHostList(){
        this.isShowLEDHostList = !this.isShowLEDHostList ;
        this.$bus.emit('showLEDHostList',this.isShowLEDHostList);
      },
      showFollowStyle(){
        this.$nextTick(function(){
          this.isShowFollowStyle = !this.isShowFollowStyle ;
          if(!this.isShowFollowStyle){
            $bus.emit('closeInspection');
            this.controlLEDRoadShow(this.isShowFollowStyle);
          }else{
            this.controlLEDRoadShow(this.isShowFollowStyle);
            $bus.emit('startInspection');
            
          } 
        })  
      },
      showSystemInfo(){
        this.$bus.emit('showSystemInfo');
      },
      showLEDEcharts(){
        this.$bus.emit('showLEDEcharts');
      },
      showEchartsAreas(){
        this.$bus.emit('showEchartsAreas');
      },
      trackOverlay(type){
        $bus.emit('trackOverlay',type);
      }
    },
}
</script>

<style ecoped>
  .toolBar{
    position: absolute;
    display: flex;
    width:500px;
    height: 50px;
    justify-content: space-around;   

    top: 83.5%;
    left: 0;
  }

  .toolBarHead{
    position: absolute;
    top: 0;
    left: 0;
    width: 50px;
    height: 50px;
    border-radius: 50px;
    padding-top: 10px;
    font-size: 2em;
    color: #fff;
    background-color: rgb(0, 204, 255);
  }

  .toolBarBody{
    display: flex;
    width:420px;
    height: 50px;
    margin-left: 50px;
    padding-top: 5px;
    /* line-height: 100px; */
    justify-content: space-around;   

    top: 2%;
    left: 1%;
    font-size: 1.7em;  
    /* background: rgba(255,255,255,.3); */
    /* border-radius: 50px; */
  }
  .toolBarItem{
    display: block;
    width: 40px;
    height: 40px;
    padding-top: 8px;
    color: #fff;
    background-color: rgb(47, 101, 182);
    border-radius: 50px;
  }
  .spanItem{
    background-color: orange;
  }
  /* .el-icon{
    color: #ffff;
  } */
  .el-icon:hover{
    color: aqua;
  }

 

  .inspectionDiv{
    position: absolute; 
    top: -100%;
    left: 32.5%; 
    width: 170px;
    height: 40px;
    /* border: 2px solid red; */
    /* background-color: blue; */
    display: flex; 
    justify-content: space-around;
  }

</style>